import React from "react";
import { FlagCountResponse } from "../../api/Items";
import LabeledCheckbox from "../../shared-components/LabeledCheckbox";
import { classNames } from "../../utils";
import { SummaryFilterTypeEnum } from "./SidebarSummary";
import { behaviorMap, useFamaFlags } from "../../api/FamaFlags";
import { countByName, FilterCount } from "./sidebarFilterCount";

type Props = {
  flagCount?: FlagCountResponse;
  filteredFlagCount?: FlagCountResponse;
  filtersActive?: boolean;
  applyFilterByType?: (
    type: SummaryFilterTypeEnum,
    event: React.ChangeEvent<HTMLInputElement>,
    source: string
  ) => void;
  hasCheckbox: boolean;
  onSelectionChange?: (key: string, value: boolean) => void;
  selections?: string[];
};

export const SidebarBehaviors = ({
  flagCount,
  filteredFlagCount,
  filtersActive = false,
  applyFilterByType,
  hasCheckbox = false,
  onSelectionChange,
  selections,
}: Props) => {
  const showFiltered = filtersActive && !!filteredFlagCount;
  const { behaviorMappingActions } = useFamaFlags();
  let behaviorsOptions: string[] = [];
  if (flagCount) {
    const newBehaviors: string[] = [];
    flagCount?.behaviors?.groups.forEach((behavior) => {
      if (!newBehaviors.includes(behavior.name)) {
        newBehaviors.push(behavior.name);
      }
    });

    behaviorsOptions = newBehaviors;
  }

  return (
    <div>
      {behaviorsOptions.sort().map((behavior: string) => {
        const baseline =
          countByName(flagCount?.behaviors.groups, behavior) ?? 0;
        const current = showFiltered
          ? countByName(filteredFlagCount?.behaviors.groups, behavior) ?? 0
          : baseline;
        const mappedBehavior = behaviorMap(
          behavior,
          behaviorMappingActions,
          "key"
        )
          ?.toLowerCase()
          .replace(/\b(\w)/g, (s) => s.toUpperCase());
        return (
          <div
            className="flex gap-1 capitalize items-center text-sm mb-1 font-medium"
            key={behavior}
          >
            {hasCheckbox ? (
              <>
                {selections ? (
                  <LabeledCheckbox
                    name={behavior}
                    onChange={(e) => {
                      applyFilterByType?.(
                        SummaryFilterTypeEnum.behavior,
                        e,
                        behavior
                      );
                      onSelectionChange?.(behavior, e.target.checked);
                    }}
                    checked={selections.includes(behavior)}
                  ></LabeledCheckbox>
                ) : (
                  <LabeledCheckbox
                    name={behavior}
                    onChange={(e) => {
                      applyFilterByType?.(
                        SummaryFilterTypeEnum.behavior,
                        e,
                        behavior
                      );
                      onSelectionChange?.(behavior, e.target.checked);
                    }}
                  ></LabeledCheckbox>
                )}
              </>
            ) : (
              <Dot />
            )}
            {mappedBehavior}{" "}
            <FilterCount
              current={current}
              total={baseline}
              showTotal={showFiltered}
            />
          </div>
        );
      })}
    </div>
  );
};

function Dot({ className }: { className?: string }) {
  return (
    <span
      className={classNames(
        "inline-block h-1 w-1 mr-2 rounded-full",
        className ?? "bg-gray-500"
      )}
    ></span>
  );
}
